import React, { FC } from "react";
import {
  AdminApiContext,
  PrimerMicrositeEditor as BasePrimerMicrositeEditor,
  GregPrimerTheme,
} from "@getregistered/greg-editors";
import ErrorHandler from "../ErrorHandler";
import { PrimerMicrositeEditorUIProps } from "./types";

export const PrimerMicrositeEditor: FC<PrimerMicrositeEditorUIProps> = ({
  apiClient,
  ...props
}) => {
  return (
    <ErrorHandler>
      <GregPrimerTheme>
        <AdminApiContext.Provider value={apiClient}>
          <BasePrimerMicrositeEditor {...props} />
        </AdminApiContext.Provider>
      </GregPrimerTheme>
    </ErrorHandler>
  );
};
